function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4917 1.50863C18.2078 1.22596 17.8707 1.00235 17.5 0.850696C17.1292 0.699043 16.732 0.622358 16.3314 0.625069C15.9308 0.627781 15.5347 0.709837 15.1661 0.866496C14.7974 1.02316 14.4634 1.25131 14.1833 1.53779L2.1 13.6211L0.625 19.3753L6.37917 17.8995L18.4625 5.81612C18.7491 5.53624 18.9773 5.20232 19.134 4.83369C19.2907 4.46505 19.3728 4.06901 19.3755 3.66846C19.3782 3.26791 19.3015 2.87079 19.1498 2.50006C18.9981 2.12934 18.7744 1.79237 18.4917 1.50863V1.50863Z",
  stroke: "white",
  strokeOpacity: 0.8,
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.839 1.8826L18.1173 6.16093",
  stroke: "white",
  strokeOpacity: 0.8,
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.10178 13.6198L6.38428 17.8948",
  stroke: "white",
  strokeOpacity: 0.8,
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPencilOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutline);
export default __webpack_public_path__ + "static/media/pencil-outline.ec1e7bc7.svg";
export { ForwardRef as ReactComponent };